/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EstimateLineItem
 */
export interface EstimateLineItem {
    /**
     * 
     * @type {number}
     * @memberof EstimateLineItem
     */
    lineItemId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EstimateLineItem
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof EstimateLineItem
     */
    quantity: number | null;
    /**
     * 
     * @type {string}
     * @memberof EstimateLineItem
     */
    unit: string | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLineItem
     */
    unitPriceCents: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLineItem
     */
    rcvCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLineItem
     */
    taxCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLineItem
     */
    opCents?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EstimateLineItem
     */
    lineItemNumber?: string | null;
}

/**
 * Check if a given object implements the EstimateLineItem interface.
 */
export function instanceOfEstimateLineItem(value: object): value is EstimateLineItem {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('unitPriceCents' in value) || value['unitPriceCents'] === undefined) return false;
    return true;
}

export function EstimateLineItemFromJSON(json: any): EstimateLineItem {
    return EstimateLineItemFromJSONTyped(json, false);
}

export function EstimateLineItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateLineItem {
    if (json == null) {
        return json;
    }
    return {
        
        'lineItemId': json['lineItemId'] == null ? undefined : json['lineItemId'],
        'description': json['description'],
        'quantity': json['quantity'],
        'unit': json['unit'],
        'unitPriceCents': json['unitPriceCents'],
        'rcvCents': json['rcvCents'] == null ? undefined : json['rcvCents'],
        'taxCents': json['taxCents'] == null ? undefined : json['taxCents'],
        'opCents': json['opCents'] == null ? undefined : json['opCents'],
        'lineItemNumber': json['lineItemNumber'] == null ? undefined : json['lineItemNumber'],
    };
}

export function EstimateLineItemToJSON(json: any): EstimateLineItem {
    return EstimateLineItemToJSONTyped(json, false);
}

export function EstimateLineItemToJSONTyped(value?: EstimateLineItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lineItemId': value['lineItemId'],
        'description': value['description'],
        'quantity': value['quantity'],
        'unit': value['unit'],
        'unitPriceCents': value['unitPriceCents'],
        'rcvCents': value['rcvCents'],
        'taxCents': value['taxCents'],
        'opCents': value['opCents'],
        'lineItemNumber': value['lineItemNumber'],
    };
}

